<i18n>
zh:
    infoTab: [
        '<span class="en">space</span><span class="sup">+</span><br class="mobile"/><span>多元化空间</span>', 
        '<span class="en">service</span><span class="sup">+</span><br class="mobile"/><span>全方位服务</span>', 
        '<span class="en">value</span><span class="sup">+</span><br class="mobile"/><span>可持续增值</span>'
    ]
en:
    infoTab: [
        '<span class="en">space</span><span class="sup">+</span><br class="mobile"/><span>多元化空间</span>', 
        '<span class="en">service</span><span class="sup">+</span><br class="mobile"/><span>全方位服务</span>', 
        '<span class="en">value</span><span class="sup">+</span><br class="mobile"/><span>可持续增值</span>'
    ]
</i18n>
<template>
    <div class="container">
        <div class="info">
            <div class="tab">
                <div class="item" 
                v-html="$t('infoTab[0]')" 
                :class="{active: infoTabActiveIndex == 0}"
                @click="infoTabActiveIndex = 0"></div>
                <div class="line"></div>
                <div class="item" 
                v-html="$t('infoTab[1]')"
                :class="{active: infoTabActiveIndex == 1}"
                @click="infoTabActiveIndex = 1"></div>
                <div class="line"></div>
                <div class="item" 
                v-html="$t('infoTab[2]')"
                :class="{active: infoTabActiveIndex == 2}"
                @click="infoTabActiveIndex = 2"></div>
            </div>
            <div class="content">
                <!-- 多元化空间 -->
                <div class="content_item" v-if="infoTabActiveIndex == 0">
                    <div class="content_tab">
                        <div class="item" 
                        :class="{active: contentTabActiveIndex == 1}">
                            <div class="btn" 
                            @click="contentTabActiveIndex = 1">CORE</div>
                            <div class="text">{{data.diversified_space.core}}</div>
                        </div>
                        <div class="item" 
                        :class="{active: contentTabActiveIndex == 2}">
                            <div class="btn" 
                            @click="contentTabActiveIndex = 2">FLEX</div>
                            <div class="text">{{data.diversified_space.flex}}</div>
                        </div>
                    </div>
                    <!-- content_item_text -->
                    <div class="content_tab_text">
                        <p v-if="contentTabActiveIndex == 1">{{data.diversified_space.core}}</p>
                        <p v-if="contentTabActiveIndex == 2">{{data.diversified_space.flex}}</p>
                    </div>
                    <!-- core 办公场所 -->
                    <div class="city" v-if="contentTabActiveIndex == 1">
                        <div class="city_tab">
                            <template v-for="(item, index) in data.city">
                                <div class="item" :key="index"
                                :class="{active: cityTabActiveIndex == index}"
                                @click="cityTabActiveIndex = index">{{item.city_name}}</div>
                                <div class="line" :key="index + 'line'"></div>
                            </template>
                        </div>
                        <template v-if="data.city.length > 0">
                            <ImagesBanner 
                            :data="data.city[cityTabActiveIndex].project_pc" 
                            :mobileData="data.city[cityTabActiveIndex].project_mobile"
                            :name="data.city[cityTabActiveIndex].city_name"/>
                        </template>
                    </div>
                    <!-- flex 办公空间 -->
                    <div class="office_space" v-if="contentTabActiveIndex == 2">
                        <template v-for="(item, index) in data.product">
                            <router-link class="item" v-if="index < 3" :key="index" to="/office#flex">
                                <div class="text">
                                    <div class="title">{{item.name}}</div>
                                    <div class="desc" v-html="textToHtml(item.desc)"></div>
                                    <div class="desc2">{{item.web_desc}}</div>
                                </div>
                                <div class="cover" :style="`background-image: url(${item.image});`"></div>
                            </router-link>
                        </template>
                    </div>
                </div>
                <!-- 全方位服务 -->
                <div class="content_item" v-if="infoTabActiveIndex == 1">
                    <div class="content_text" v-html="textToHtml(data.full_service.desc)"></div>
                    <router-link to="/service/property">
                    <img class="content_img pc" :src="data.full_service.image" alt=""/>
                    <img class="content_img mobile" :src="data.full_service.web_image" alt=""/>
                    </router-link>
                </div>
                <!-- 可持续增值 -->
                <div class="content_item" v-if="infoTabActiveIndex == 2">
                    <div class="content_text" v-html="textToHtml(data.sustainable_value.desc)"></div>
                    <div class="link_group">
                        <router-link class="item" v-for="(item, index) in linkGroup" :key="index" :to="item.link">
                            <div class="cover pc" :style="`background-image: url(${item.image});`"></div>
                            <div class="cover mobile" :style="`background-image: url(${item.web_image});`"></div>
                            <div class="text">
                                <div class="icon" :style="`background-image: url(${item.icon});`"></div>
                                <div class="title1">{{item.title1}}</div>
                                <div class="title2">{{item.title2}}</div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import lineBreaks from '../../utils/lineBreaks';
import ImagesBanner from '../imagesBanner.vue';
export default {
    name: "indexInfo",
    props: [ 'data' ],
    data() {
        return {
            linkGroup: [
                {
                    title1: 'ESG',
                    title2: '可持续发展',
                    icon: require('@/assets/images/icon_value_01.png'),
                    image: require('@/assets/images/value_cover_01.jpg'),
                    web_image: require('@/assets/images/value_cover_011.jpg'),
                    link: '/value/esg',
                },
                {
                    title1: 'development',
                    title2: '企业发展需求',
                    icon: require('@/assets/images/icon_value_02.png'),
                    image: require('@/assets/images/value_cover_02.jpg'),
                    web_image: require('@/assets/images/value_cover_012.jpg'),
                    link: '/value/edn',
                },
                {
                    title1: 'community',
                    title2: '办公社群服务',
                    icon: require('@/assets/images/icon_value_03.png'),
                    image: require('@/assets/images/value_cover_03.jpg'),
                    web_image: require('@/assets/images/value_cover_013.jpg'),
                    link: '/value/community',
                },
            ],
            infoTabActiveIndex: 0,
            contentTabActiveIndex: 1,
            cityTabActiveIndex: 0,
        };
    },
    computed: {
        textToHtml: lineBreaks.textToHtml
    },
    components: {
        ImagesBanner,
        
    },
    mounted() {
        
    },
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<style scoped lang="scss">
.info{
    padding-bottom: 1rem;
    @media only screen and (max-width: 1200px) {
        padding-bottom: 0;
    }
    img{
        width: 100%;
    }
}
.tab{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: .6rem 0 .8rem;
    .line{
        width: 1px;
        height: .3rem;
        background: rgba($color: #ff4a38, $alpha: .5);
    }
    .item{
        color: #000;
        font: .3rem 'shuionworkx';
        cursor: pointer;
        &:hover,
        &.active{
            color: #ff4a38;
        }
        /deep/{
            .en{
                font-size: .48rem;
            }
            .sup{
                font-size: .28rem;
                vertical-align: super;
            }
            .mobile{
                display: none;
            }
        }
    }
    @media only screen and (max-width: 1200px) {
        padding: 1.2rem 0 1.1rem;
        .line{
            height: 1.5rem;
        }
        .item{
            flex: 1;
            text-align: center;
            font-size: .6rem;
            /deep/{
                .en{
                    font-size: .85rem;
                }
                .sup{
                    font-size: .5rem;
                    vertical-align: super;
                }
                .mobile{
                    display: block;
                }
            }
        }
    }
}
.content_tab{
    display: flex;
    justify-content: space-between;
    margin-bottom: .9rem;
    $tabColor1: #e5e5e5;
    $tabColor2: #ff4028;
    .item{
        width: 5.5rem;
        height: 1.95rem;
        display: flex;
        &.active{
            // background: #ff7968;
            background-image: linear-gradient(-135deg, transparent .54rem, #ff7968 0);
            .btn{
                color: #fff;
                filter: drop-shadow(0 .05rem .05rem rgba(#000, .2));
                background-image: url('~@/assets/images/icon_index_info_btn_left_checked.png');
            }
            &:nth-of-type(2){
                background-image: linear-gradient(135deg, transparent .54rem, #ff7968 0);
                .btn{
                    background-image: url('~@/assets/images/icon_index_info_btn_right_checked.png');
                }
            }
            .text{
                display: flex;
            }
        }
        .btn{
            width: 1.1rem;
            height: 1.1rem;
            font: .38rem 'shuionworkx';
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 1;
            cursor: pointer;
            margin-top: .36rem;
            transform: translate(.02rem, 0);
            background: url('~@/assets/images/icon_index_info_btn_left.png') no-repeat 0/100%;
        }
        &:nth-of-type(1){
            flex-direction: row-reverse;
        }
        &:nth-of-type(2){
            .btn{
                transform: translate(-.02rem, 0);
                background-image: url('~@/assets/images/icon_index_info_btn_right.png');
            }
        }
        .text{
            flex: 1;
            color: #fff;
            padding: 0 .3rem;
            text-align: justify;
            display: flex;
            align-items: center;
            line-height: 1.8;
            display: none;
        }
    }
    @media only screen and (max-width: 1200px) {
        // margin-bottom: 1.2rem;
        justify-content: center;
        .item,
        .item:nth-of-type(2){
            width: 4.6rem;
            height: auto;
            justify-content: center;
            &.active{
                background: none;
                .btn{
                    background-image: url('~@/assets/images/icon_index_info_btn_left_checked.png');
                }
                .text{
                    display: none;
                }
            }
            .btn{
                margin-top: 0;
                width: 2.4rem;
                height: 2.4rem;
                font-size: .72rem;
                background-image: url('~@/assets/images/icon_index_info_btn_left.png');
            }
            .text{
                display: none;
            }
        }
    }
}
.content_tab_text{
    display: none;
    background: #ff7968;
    color: #fff;
    font-size: .36rem;
    padding: .4rem 1rem;
    line-height: 1.8;
    text-align: justify;
    margin-bottom: 1rem;
    @media only screen and (max-width: 1200px) {
        display: block;
    }
}
.city{
    .city_tab{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: .26rem;
        color: rgba($color: #000000, $alpha: .5);
        line-height: 1;
        margin-bottom: .5rem;
        .item{
            cursor: pointer;
            &:hover,
            &.active{
                color: #ff4836;
            }
        }
        .line{
            width: 1px;
            height: .3rem;
            background: rgba($color: #ff4836, $alpha: .5);
            margin: 0 .2rem;
            &:last-child{
                display: none;
            }
        }
    }
    @media only screen and (max-width: 1200px) {
        .city_tab{
            font-size: .6rem;
            margin: 1.2rem 0;
            .item{
                flex: 1;
                text-align: center;
                &:hover,
                &.active{
                    font-weight: bold;
                }
            }
            .line{
                height: .54rem;
            }
        }
    }
}
.office_space{
    display: flex;
    justify-content: space-between;
    .item{
        width: 3.73rem;
        .text{
            position: relative;
            padding-left: .7rem;
            min-height: .63rem;
            margin-bottom: .3rem;
            &::before{
                content: '';
                display: block;
                position: absolute;
                left: 0;
                top: 50%;
                transform: translate(0, -50%);
                width: .53rem;
                height: .63rem;
                background: url('~@/assets/images/icon_arrow_next.svg') no-repeat 0/100%;
            }
            .title{
                font-size: .2rem;
                // font-weight: bold;
            }
            .desc2{
                display: none;
            }
        }
        .cover{
            width: 100%;
            height: 1.95rem;
            background: no-repeat center/cover;
        }
    }
    @media only screen and (max-width: 1200px) {
        display: block;
        padding: 0 .6rem;
        .item{
            width: 100%;
            display: flex;
            flex-direction: row-reverse;
            border-bottom: 2px solid #e6efee;
            padding-bottom: .4rem;
            margin-bottom: .4rem;
            &:last-child{
                border-bottom: none;
                padding-bottom: 0;
                margin-bottom: 0;
            }
            .cover{
                width: 3.9rem;
                height: 4.3rem;
            }
            .text{
                flex: 1;
                &::before{
                    display: none;
                }
                .title{
                    font-size: .48rem;
                    margin-bottom: .5rem;
                    display: flex;
                    align-items: center;
                    font-weight: bold;
                    &::before{
                        content: '';
                        display: block;
                        width: .4rem;
                        height: .47rem;
                        background: url('~@/assets/images/icon_arrow_next.svg') no-repeat 0/100%;
                        margin-right: .3rem;
                    }
                }
                .desc{
                    line-height: 1.6;
                    margin-bottom: .2rem;
                }
                .desc2{
                    line-height: 1.6;
                    font-size: .3rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    /*! autoprefixer: off */
                    -webkit-box-orient: vertical;
                }
            }
        }
    }
}
.content_text{
    line-height: 1.8;
    margin-bottom: .2rem;
    @media only screen and (max-width: 1200px) {
        padding: 0 1rem;
        margin-bottom: .6rem;
    }
}
.content_img{
    &.mobile{
        display: none;
    }
    @media only screen and (max-width: 1200px) {
        &.mobile{
            display: block;
        }
        &.pc{
            display: none;
        }
    }
}
.link_group{
    display: flex;
    position: relative;
    &::before,
    &::after{
        content: "";
        display: block;
        width: 1px;
        height: 4.55rem;
        background: #ff4028;
        position: absolute;
        top: 1.05rem;
        left: 33.33%;
        z-index: 1;
    }
    &::after{
        left: 66.66%;
    }
    .item{
        flex: 1;
        position: relative;
        display: block;
        &::after{
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: .8;
            background-image: linear-gradient(to top, #ff4028, #ff4028 1%, transparent 95%);
            display: none;
        }
        &:hover{
            &::after{
                display: block;
            }
        }
        .cover{
            width: 100%;
            height: 6.16rem;
            background: no-repeat center/cover;
            &.mobile{
                display: none;
            }
        }
        .text{
            position: absolute;
            left: .8rem;
            top: 3.8rem;
            z-index: 1;
            .icon{
                width: .64rem;
                height: .64rem;
                background: no-repeat center/cover;
            }
            .title1{
                font: .38rem 'shuionworkx';
                color: #ff4a32;
            }
            .title2{
                font-size: .26rem;
            }
        }
    }
    @media only screen and (max-width: 1200px) {
        display: block;
        &::before,
        &::after{
            width: 11.2rem;
            height: 1px;
            left: 50%;
            top: 33.33%;
            transform: translate(-50%, 0);
        }
        &::after{
            left: 50%;
            top: 66.66%;
        }
        .item{
            &:hover{
                &::after{
                    display: none;
                }
            }
            .cover{
                height: 5.2rem;
                &.pc{
                    display: none;
                }
                &.mobile{
                    display: block;
                }
            }
            .text{
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .icon{
                    width: 1.6rem;
                    height: 1.6rem;
                }
                .title1{
                    font-size: .85rem;
                    margin: .2rem 0;
                }
                .title2{
                    font-size: .6rem;
                }
            }
        }
    }
}
</style>